export default class AddProductButton extends HTMLButtonElement {
    constructor() {
        super();
    }

    connectedCallback() {
        $(this).on('click', function (e) {
            this.addProductItem();
        });
    }

    addProductItem() {
        let orderId = document.querySelector('select[name="order_id"]').value;
        let url = this.getAttribute('data-href');
        var excludedIds = [];
        var productsCount = $('select[name^="order_line_id"]').first().find('option').length - 1;
        var selectCounts = $('select[name^="order_line_id"]').length + 1;
        let productAddButton = document.querySelector('button[name^="add-product-button"]');

        $('select[name^="order_line_id"]').each(function(){
            excludedIds.push($(this).val());
        });

        if (selectCounts >= productsCount) {
            productAddButton.style = 'display: none';
        } else {
            productAddButton.style = 'display: block';
        }

        if (selectCounts <= productsCount) {
            HegydCore.sendRequest(url, 'POST', {id: orderId, excludedIds: excludedIds}, function (data) {
                if (data.hasOwnProperty('item')) {
                    $('#products-list').append(data.item);

                    $('.del-button').removeClass('d-none');

                    $('.product-item-block:first .del-button').remove();
                } else {
                    toastr.error(data.errorMessage);
                }

            }, function (data) {
                if (data.hasOwnProperty('errorMessage')) {
                    toastr.error(data.errorMessage);
                }
            });
        }
    }
}
